<button
  mat-icon-button
  [matTooltip]="tooltipText"
  [matTooltipPosition]="tooltipPosition">
  <div class="flex items-center rounded-full overflow-hidden p-1">
    <!-- <ng-container *ngIf="isGoogleIcon; else fuseIcon">
      <mat-icon
        class="material-icons icon-size-5"
      >
        {{ icon }}
      </mat-icon>
    </ng-container> -->

    <!-- <ng-template #fuseIcon> -->
    <mat-icon
      class="icon-size-6 p-1 m-0"
      [svgIcon]="icon">
    </mat-icon>
  </div>
</button>
